import { ItemStore } from "@mobx/store/locations/interfaces";
import { RACK_SECTION_TYPE3, TypePartialRackItem3 } from "@mobx/store/locations/types";
import mainLocationsStore from "@mobx/store/locations";
import { MutableRefObject, useMemo } from "react";
import { formatRackDisplayName3, toRackSectionData3 } from "@mobx/store/connections";
import { useSchemeDragItem3 } from "./useShemeDragItem3";

export const useRackSectionSchemeDrag = (
  itemStore: ItemStore,
  self: MutableRefObject<HTMLElement | null>
) => {
  const rack = itemStore.rackStore.rack;
  const item = itemStore.item;
  const locationStore = mainLocationsStore.activeLocation;
  const buildingStore = locationStore?.activeBuilding;
  const rackItem = ("pos" in item ? item : undefined) as TypePartialRackItem3 | undefined;
  const canSchemeDrag = rackItem !== undefined && rackItem.pos !== RACK_SECTION_TYPE3.NULL;
  const rackDisplayName = useMemo(() => {
    return formatRackDisplayName3(
      locationStore?.location.Code,
      buildingStore?.building.name,
      rack.rack_id
    );
  }, [buildingStore?.building.name, locationStore?.location.Code, rack.rack_id]);
  const info = useMemo(
    () => (canSchemeDrag && rackItem ? toRackSectionData3(rack, rackItem, rackDisplayName) : undefined),
    [canSchemeDrag, rack, rackDisplayName, rackItem]
  );
  const schemeDragItem = useSchemeDragItem3(
    "section",
    info?.sectionKey ?? `${itemStore.itemIndex}`,
    self,
    info
  );

  return {
    ...schemeDragItem,
    canSchemeDrag,
  };
};
